import * as React from "react"

/**
 * Catches "The result of this StaticQuery could not be fetched" (and similar)
 * when cached JS requests stale query JSON after a deploy. Shows a friendly
 * message and refresh button instead of a white screen.
 */
class StaticQueryErrorBoundary extends React.Component {
  state = { hasError: false }

  static getDerivedStateFromError(error) {
    const isStaticQueryError =
      error?.message?.includes("StaticQuery could not be fetched") ||
      error?.message?.includes("Minified React error #423")
    return isStaticQueryError ? { hasError: true } : null
  }

  componentDidCatch(error, errorInfo) {
    if (this.state.hasError) {
      console.error("StaticQuery/load error (often fixed by refreshing):", error?.message)
    } else {
      throw error
    }
  }

  render() {
    if (this.state.hasError) {
      const reloadKey = "static-query-reload-attempted"
      if (typeof window !== "undefined" && !sessionStorage.getItem(reloadKey)) {
        sessionStorage.setItem(reloadKey, "1")
        window.location.reload()
        return null
      }
      return (
        <div
          style={{
            padding: "2rem",
            maxWidth: "32rem",
            margin: "4rem auto",
            fontFamily: "system-ui, sans-serif",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "1.25rem", marginBottom: "0.5rem" }}>
            Please refresh the page
          </h1>
          <p style={{ color: "#666", marginBottom: "1rem" }}>
            The site was updated. Reload to get the latest version.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              padding: "0.5rem 1rem",
              fontSize: "1rem",
              cursor: "pointer",
              backgroundColor: "#333",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
            }}
          >
            Refresh
          </button>
        </div>
      )
    }
    return this.props.children
  }
}

export default StaticQueryErrorBoundary
